import React, { useState } from 'react';
import { appFormUtil } from 'modules/common';
import * as ds from './dataService';
import {
  Autocomplete,
  TextField
} from '@mui/material';


export type SelectPersonFieldProps<T extends object> = appFormUtil.SelectFieldProps<T> & { freeTextField: keyof appFormUtil.InferReturn<T>['formState'] };

export const FC = <T extends object>(props: SelectPersonFieldProps<T>) => {

  const { data } = ds.useQuery(`${props.form.formState[props.freeTextField] ?? ''}`);


  return (
    <Autocomplete
      disablePortal
      options={[...data]}
      renderInput={(params) => (
        <TextField
          {...params}
          key={`${params.id}${params}`}
          onChange={(e) => props.form.dispatch({
            type: 'UPDATE',
            payload: {
              property: props.freeTextField,
              value: e.currentTarget.value as T[keyof T]
            }
          })}
          label='controlled'
          variant='standard'
        />
      )}
      getOptionLabel={(option) => option.label}
      value={props.form.formState[props.fieldName] as ds.IData}
      onChange={(event: any, newValue: { id: string; label: string } | null) => {
        props.form.dispatch({
          type: 'UPDATE',
          payload: {
            property: props.fieldName,
            value: newValue as T[keyof T]
          }
        });
      }}

    />

  );
};
